<template>
  <Panel :class="'tournament-format'">
    <Subheader
      :text="$t('_ios_tournament_details_stage_section', 'Tournament format')"
      class="tournament-settings-wrapper__title mb-5"
    />
    <div class="row tournament-format-pick">
      <TournamentFormatTypeSetting class="col" />
    </div>
    <div class="row mt-5 match-options-format">
      <div class="col-auto match-duration">
        <MatchDuration class="match-duration-picker" />
      </div>
      <div class="col-auto match-autofinish">
        <StageSettingAutofinishMatch />
      </div>
      <!--  Require result attachments  -->
      <div class="col-3 match-require-attachment">
        <StageSettingRequireAttachment />
      </div>
      <div class="col-auto match-autofinish">
        <SettingStageResultsBlocked />
      </div>
    </div>
    <StageSettingCheckIn class="mt-5 stage-check-in" />
    <div class="sophisticated-tournament-settings">
      <TextBlock
        tag="p"
        variant="secondary"
        :text="
          $t(
            '_web_tournament_create_bracket_tip',
            'More sophisticated tournament and bracket structure setting can be found in Brackets'
          ) +
            ' -> ' +
            $t(
              '_web_tournament_settings_will_create',
              'Settings page after tournament will be created'
            )
        "
      />
    </div>
  </Panel>
</template>

<script>
import { mapMutations } from 'vuex';
import { translate } from '@/mixins/translate';
import { ONE_DAY_IN_SECONDS, ONE_HOUR } from '@/constants/time';
import dateMethods from '@/mixins/dateMethods';

import TournamentFormatTypeSetting from '@/views/tournaments/management/singleTournament/stages/components/SettingsStageType.vue';
// import TournamentSettingAutoprocessing from '@/views/tournaments/management/singleTournament/components/SettingsAutoprocessing';
import StageSettingCheckIn from '@/views/tournaments/management/singleTournament/stages/components/SettingsStageCheckIn.vue';
import StageSettingAutofinishMatch from '@/views/tournaments/management/singleTournament/stages/components/SettingsStageAutocompleteMatch';
import MatchDuration from '@/views/tournaments/management/singleTournament/stages/components/MatchDuration.vue';
import StageSettingRequireAttachment from '@/views/tournaments/management/singleTournament/stages/components/SettingsStageRequiresAttachment';
import SettingStageResultsBlocked from '@/views/tournaments/management/singleTournament/stages/components/SettingStageResultsBlocked';
// import TournamentSettingQualificationType from '@/views/tournaments/management/singleTournament/components/SettingsQualificationType';

import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
import TextBlock from '@/components/atoms/TextBlock';
export default {
  name: 'SectionTournamentFormat',
  components: {
    TextBlock,
    Panel,
    Subheader,
    TournamentFormatTypeSetting,
    StageSettingCheckIn,
    StageSettingAutofinishMatch,
    MatchDuration,
    StageSettingRequireAttachment,
    SettingStageResultsBlocked,
    // TournamentSettingAutoprocessing,
    // TournamentSettingQualificationType,
  },
  mixins: [...dateMethods, translate('_web_tournament_settings')],
  created() {
    this.createNewTournamentStage({
      ...this.getDefaultTitle(1),
      ...this.getDefaultDates(),
      ...this.getCheckInDefaults(),
    });
  },
  methods: {
    ...mapMutations(['createNewTournamentStage']),
    getDefaultTitle(index = 1) {
      return {
        title: this.$t(
          '_web_tournament_stage_editor_default_title',
          'Stage {index}',
          { index }
        ),
      };
    },
    getDefaultDates() {
      const lastStageDateEnd = this.getNowSeconds();
      return {
        date_start: lastStageDateEnd + ONE_DAY_IN_SECONDS,
        date_end: lastStageDateEnd + 2 * ONE_DAY_IN_SECONDS,
      };
    },
    getCheckInDefaults() {
      const { date_start } = this.getDefaultDates();
      return {
        check_in_start_date: date_start - ONE_HOUR,
      };
    },
  },
};
</script>

<style lang="scss">
.tournament-format {
  padding: 20px !important;
}

.stage-type-wrapper {
  gap: 10px;
  padding-bottom: 10px !important;
}

.match-options-format div {
  padding-right: 10px !important;
}

.match-duration label {
  font-size: $hr-text-small !important;
  margin-bottom: 15px !important;
  font-weight: 600;
}

.match-duration-picker {
  padding-bottom: 15px !important;
}

.match-duration input {
  background-color: $hr-bg-header !important;
}

.match-autofinish label {
  font-size: $hr-text-small !important;
  margin-bottom: 15px !important;
  font-weight: 600;
}

.match-autofinish .segment-control-btn {
  background-color: $hr-bg-header;
}

.match-require-attachment label {
  font-size: $hr-text-small !important;
  margin-bottom: 15px !important;
  font-weight: 600;
}

.match-require-attachment .segment-control-btn {
  background-color: $hr-bg-header;
}

.stage-check-in label {
  font-size: $hr-text-small !important;
  margin-bottom: 15px !important;
  font-weight: 600;
  gap: 10px !important;
}

.stage-check-in {
  gap: 32px;
}

.stage-check-in .segment-control-btn {
  background-color: $hr-bg-header;
}

.stage-check-in .date-time-input input {
  background-color: $hr-bg-header;
}

.stage-check-in .text-block--muted {
  padding: 25px 0px 0px 10px;
  color: $hr-text-primary;
  font-weight: 600;
}

.sophisticated-tournament-settings .text-block--secondary {
  padding-top: 20px !important;
  font-size: $hr-text-small !important;
  font-weight: 600;
}
</style>
